(function () {
  'use strict';
  var root = document.getElementById('wc2026-today');
  if (!root) return;
  var FEED = root.dataset.feed;
  var HUB  = root.dataset.hub;
  var FLAG = 'https://cdn.jsdelivr.net/gh/HatScripts/circle-flags/flags/';
  var elCards = root.querySelector('[data-wc-cards]');
  var elSub   = root.querySelector('[data-wc-sub]');
  var elTitle = root.querySelector('[data-wc-title]');

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function flag(iso, colors, name){
    var bg = (colors && colors.length) ? 'background:linear-gradient(135deg,' + colors.join(',') + ')' : '';
    return '<span class="wc-flag" style="' + bg + '"><img src="' + FLAG + iso + '.svg" alt="' + esc(name) + '" loading="lazy" decoding="async"></span>';
  }
  function statusPill(m){
    if (m.status === 'live')     return '<span class="wc-status wc-status--live"><span class="wc-dot"></span><span>' + (m.minute ? "משחק חי · " + m.minute + "'" : 'משחק חי') + '</span></span>';
    if (m.status === 'finished') return '<span class="wc-status wc-status--done"><span>הסתיים</span></span>';
    return '<span class="wc-status wc-status--soon"><span>טרם שוחק</span></span>';
  }
  function mid(m){
    if (m.status === 'finished' || m.status === 'live') {
      var s = m.score || [0,0];
      return '<span class="wc-pair wc-score"><span>' + s[0] + '</span><span class="wc-pair__c">:</span><span>' + s[1] + '</span></span>';
    }
    return '<span class="wc-time">' + esc(m.time_il || '') + '</span><span class="wc-time__tz">שעון ישראל</span>';
  }
  function card(m){
    var t1win = m.status === 'finished' && m.score && m.score[0] > m.score[1];
    var t2win = m.status === 'finished' && m.score && m.score[1] > m.score[0];
    var cls = m.status === 'live' ? ' is-live' : (m.status === 'finished' ? ' is-finished' : '');
    return '<a class="wc-card' + cls + '" href="' + HUB + '" style="text-decoration:none">' +
      '<div class="wc-card__meta"><div class="wc-card__metaleft"><span class="wc-badge wc-badge--group">בית ' + esc(m.group || '') + '</span></div>' + statusPill(m) + '</div>' +
      '<div class="wc-board">' +
        '<div class="wc-team wc-team--1' + (t1win ? ' is-win' : '') + '">' + flag(m.t1_iso, m.t1_flag, m.t1_he) + '<span class="wc-team__name">' + esc(m.t1_short || m.t1_he) + '</span></div>' +
        '<div class="wc-mid">' + mid(m) + '</div>' +
        '<div class="wc-team wc-team--2' + (t2win ? ' is-win' : '') + '"><span class="wc-team__name">' + esc(m.t2_short || m.t2_he) + '</span>' + flag(m.t2_iso, m.t2_flag, m.t2_he) + '</div>' +
      '</div>' +
    '</a>';
  }
  function israelKey(){
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Jerusalem', year:'numeric', month:'2-digit', day:'2-digit' }).format(new Date()); }
    catch (e) { return null; }
  }

  function render(d){
    var matches = (d && d.matches) || [];
    if (!matches.length) { root.hidden = true; return; }
    var key = israelKey();
    var list = matches.filter(function(m){ return key ? m.date_key === key : m.is_today; });
    if (!list.length) list = matches.filter(function(m){ return m.is_today; });
    var heading = 'היום';
    if (!list.length) {
      // fall back to the next match day
      var future = matches.filter(function(m){ return m.ts > Date.now(); }).sort(function(a,b){ return a.ts - b.ts; });
      if (!future.length) { root.hidden = true; return; }
      var nk = future[0].date_key;
      list = matches.filter(function(m){ return m.date_key === nk; });
      heading = 'המשחקים הקרובים';
      if (elTitle) elTitle.innerHTML = 'המשחקים <b>הקרובים</b>';
      if (elSub) elSub.textContent = (future[0].dow_he || '') + ' ' + (future[0].date_il || '') + ' · שעון ישראל';
    } else {
      if (elSub) elSub.textContent = list.length + ' משחקים · שעון ישראל';
    }
    // earliest first
    list.sort(function(a,b){ return (a.ts||0) - (b.ts||0); });
    elCards.innerHTML = list.map(card).join('');
    root.hidden = false;
  }

  function load(){
    fetch(FEED, { cache: 'default' })
      .then(function(r){ return r.json(); })
      .then(render)
      .catch(function(){ root.hidden = true; });
  }

  load();
  // refresh for live scores while the page is open (every 60s, only when visible)
  setInterval(function(){ if (!document.hidden) load(); }, 60000);
})();
